import styles from "./trendsLongBody.module.css";
import { useState } from "react";


type Props = {
  faqData: any;
}

export function TrendsLongBody({ faqData }: Props) {
  const [readMore, setReadMore] = useState(false);
  return (
    <section className={`${styles.readMore}`}>
      <div
        className={`${styles.lowerContnt} ${styles.fullHeight
          }`}
      >
        <label htmlFor="">{faqData.Faq_title || ''}</label>
        {faqData.FAQ.map((question: any, index: number) => (
          <div className={styles.faqTile} key={index}>
            <div className={styles.faqsReadmore}>
              {question.question}
            </div>
            <pre style={{fontFamily:'inherit'}} dangerouslySetInnerHTML={{ __html: question.answer }} />
          </div>
        ))}


      </div>
    </section>
  );
}
